import { FileInput } from "../../../utils/form";

const DoctorWithLicenseFile = ({ form: { control } }) =>
  <FileInput control={control} name="doctorWithLicense" label="Selfie con la credencial o DNI" helperText="Si tu matrícula es digital, una selfie con el DNI. Sino, una selfie con la matrícula física" variant="outlined" required />

export default DoctorWithLicenseFile;